import { Body1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import styles from './AboutClientPromo.css';
import { trackClientInfoPromoShow } from './tracking';
import { userProfilePromoSelector } from '../../../../../selectors/userProfile';
import { AboutTabSection } from '../AboutTabSection';

export const AboutClientPromo = () => {
  const promo = useSelector(userProfilePromoSelector);

  const isVisible = !!promo?.features.length;

  React.useEffect(() => {
    if (isVisible) {
      trackClientInfoPromoShow();
    }
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  const { title, features, info } = promo;

  return (
    <AboutTabSection title={title} testId="AboutClientPromo">
      <ul className={styles['features']}>
        {features.map((feature, index) => (
          <li className={styles['feature']} key={`promo_feature_${index}`}>
            <Body1>{feature}</Body1>
          </li>
        ))}
      </ul>

      {info && <Body1>{info}</Body1>}
    </AboutTabSection>
  );
};
